import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { Fact } from '@/types';

export function useGetFact(caseId: string | null | undefined, factId?: string | null) {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Fact, Error>(
    [QueryEntity.Fact, factId],
    async () => {
      return await fetch(`${APIBaseChronos}/api/case/${caseId}/fact/${factId}`, fetchConfigGET).then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch fact');
        }
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!caseId && !!factId },
  );
}
